import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useSelector } from "react-redux";
import axios from "axios";
import { current } from "@reduxjs/toolkit";
import Permissions from "./permissions";
import Swal from "sweetalert2";

export function BroadcastModal({
    show,
    onClose,
    baseUrl,
    currentUser,
}) {


    const [error, setError] = useState("");
    const client = useSelector((state) => state.client.client);
    const client_uid = client?.uid || "clnt_QI9Jd1m0";

    // const [responseAgent, setResponseAgent] = useState(false);

    //reset states on close
    useEffect(() => {
        if (!show) {
            setError("");
        }
    })

    // ESC key to close
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };
        if (show) window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [show, onClose]);

    const [type, setType] = useState("live");
    const [schedule, setSchedule] = useState("No");
    const [guestSpeakerName1, setGuestSpeakerName1] = useState("");
    const [guestSpeakerName2, setGuestSpeakerName2] = useState("");
    const [guestSpeakerEmail1, setGuestSpeakerEmail1] = useState("");
    const [guestSpeakerEmail2, setGuestSpeakerEmail2] = useState("");
    const [remindViaEmail, setRemindViaEmail] = useState("Yes");
    const [remindViaSms, setRemindViaSms] = useState("No");
    const [permissions, setPermissions] = useState({});
    const [loading, setLoading] = useState(true);

    const [speakerPermissions, setSpeakerPermissions] = useState([]);
    const [participantPermissions, setParticipantPermissions] = useState([]);
    const [broadcastCall, setBroadcastCall] = useState("paid");
    const [title, setTitle] = useState("");
    const [agent_uid, setAgentUid] = useState("");
    const [paymentType, setPaymentType] = useState("0");
    const [price, setPrice] = useState("");
    const [description, setDescription] = useState("");
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [reminderMinutes, setReminderMinutes] = useState("1");
    const [uploadFile, setUploadFile] = useState(null);
    const getAgentPermissions = async (agent_uid = '') => {
        try {
            if (agent_uid) {
                var param = { agent_uid: agent_uid, client_uid: client_uid };
            } else {
                var param = { token: currentUser.token, client_uid: client_uid };
            }
            await axios.get(baseUrl + '/getAgentVcomPermissions', { params: param }).then((response) => {
                if (response.data.status === "OK") {

                    setPermissions(response.data.data);
                    setSpeakerPermissions(response.data.data);

                    setBroadcastCall(response.data.broadcast_call);
                }
            })
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }
    const [agents, setAgents] = useState([{}]);
    const getAgents = async () => {
        try {
            setLoading(true);
            await axios.get(baseUrl + '/getAgents', { params: { client_uid: client_uid } }).then((response) => {
                if (response.data.status === "OK") {
                    setAgents(response.data.data);
                }
            })
        } catch (err) {
            console.error(err);
        }
    }
    useEffect(() => {
        getAgentPermissions('');
        if (currentUser?.role === "support" || currentUser?.role === "client") {
            getAgents();
        }
    }, [currentUser])


    const handleRefresh = () => {
        if (typeof onRefreshEvents === "function") {
            console.log('refresh events...');
        }
    }
    const handleCreateBroadcastClick = async () => {
        // setLoading(true);
        try {
            let formData = new FormData();
            formData.append('token', currentUser.token);
            if (currentUser.role === "support" || currentUser.role === "client") {
                formData.append('agent_uid', agent_uid);
            }
            formData.append('broadcast_call', broadcastCall);
            formData.append('title', title);
            formData.append('price_type', paymentType);
            formData.append('broadcast_price', price);
            formData.append('description', description);
            formData.append('reminder_via_email', remindViaEmail);
            formData.append('reminder_via_sms', remindViaSms);
            formData.append('schedule', schedule);
            formData.append('date', date);
            formData.append('time', time);
            formData.append('reminder_minutes', reminderMinutes);

            formData.append('speakers_permission', JSON.stringify(speakerPermissions));
            formData.append('participants_permission', JSON.stringify(participantPermissions));
            formData.append('guestspeakername1', guestSpeakerName1);
            formData.append('guestspeakername2', guestSpeakerName2);
            formData.append('guestspeakeremail1', guestSpeakerEmail1);
            formData.append('guestspeakeremail2', guestSpeakerEmail2);

            if (uploadFile) {
                formData.append("fileupload", uploadFile);
            }

            const response = await axios.post(baseUrl + '/createBroadcast', formData);

            if (response.data.status === "OK") {
                if (currentUser.role === "support" || currentUser.role === "client") {
                    const channel = new BroadcastChannel("CHAMCORE-BROADCAST-ADD-ON-BEHALF-OF-AGENT");
                    channel.postMessage({
                        type: "BROADCAST_ADDED",
                    });
                    channel.close();
                }
                Swal.fire({
                    title: 'Success',
                    icon: 'success',
                    text: response.data.data,
                    timer: 1500,
                    showConfirmButton: false,
                });
                setTimeout(() => {
                    onClose();
                }, 1500);
                if (schedule === "No") {
                    window.location.href = window.location.origin + "/agent/broadcast/" + response.data.broadcast_id;
                }
            } else {
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: response.data.data,
                    timer: 1500,
                    showConfirmButton: false
                });
            }
        } catch (err) {
            console.error(err);
        }
    }

    const handleFileDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            setUploadFile(e.dataTransfer.files[0]);
        }
    };

    const handleFileSelect = (e) => {
        if (e.target.files && e.target.files[0]) {
            setUploadFile(e.target.files[0]);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault(); // Necessary to allow drop
    };

    const handleAgentChanged = (e) => {
        e.preventDefault();
        let agent_uid = e.target.value;
        setAgentUid(agent_uid);
        getAgentPermissions(agent_uid);
    }

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="flex flex-col items-center">
                    <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                    <p className="mt-3 text-gray-600 animate-pulse">Laster inn avtaler...</p>
                </div>
            </div>
        );
    }

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        transition={{ duration: 0.25 }}
                        onClick={(e) => e.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                        className="relative bg-white rounded-2xl shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto"
                    >
                        <button
                            onClick={onClose}
                            className="absolute top-3 right-3 text-black hover:text-black-800"
                        >
                            ✕
                        </button>

                        <>
                            <div className="w-full min-h-screen bg-gradient-to-b from-white to-slate-50 p-10 animate-fadeIn">
                                <h1 className="text-3xl font-bold text-slate-900 mb-8">Opprett nytt kurs / event</h1>

                                {/* TYPE SELECT */}
                                <div className="flex gap-4 mb-10">
                                    <button
                                        onClick={() => setType("live")}
                                        className={`px-6 py-3 rounded-full text-sm font-medium transition ${type === "live"
                                            ? "bg-purple-600 text-white"
                                            : "bg-white text-slate-700 border border-slate-300 hover:bg-slate-100"
                                            }`}
                                    >
                                        🎥 Live stream
                                    </button>

                                    <button
                                        onClick={() => setType("recorded")}
                                        className={`px-6 py-3 rounded-full text-sm font-medium transition ${type === "recorded"
                                            ? "bg-purple-600 text-white"
                                            : "bg-white text-slate-700 border border-slate-300  hover:bg-slate-100"
                                            }`}
                                    >
                                        📦 Opptak (forhåndsinnspilt)
                                    </button>
                                </div>

                                {/* FORM */}
                                <div className="bg-white/80 backdrop-blur-xl border border-white/20 shadow-xl rounded-3xl p-10 max-w-4xl">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
                                        <div>
                                            <label className="text-sm text-slate-600 font-medium">Tittel</label>
                                            <input
                                                type="text"
                                                placeholder="F.eks: Digital rådgivning for nybegynnere"
                                                onChange={(e) => setTitle(e.target.value)}
                                                className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                            />
                                        </div>

                                        <div>
                                            {currentUser?.role === "support" || currentUser?.role === "client" ? (
                                                <>
                                                    <label className="text-sm text-slate-600 font-medium">Agent</label>
                                                    <select onChange={(e) => handleAgentChanged(e)} className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500">
                                                        <option>Velge agent</option>
                                                        {agents.map((agent) => (
                                                            <option value={agent.uid}>{agent.name}</option>
                                                        ))}

                                                    </select>
                                                </>
                                            ) : ('')}
                                        </div>
                                        {broadcastCall === "paid" && (
                                            <>
                                                <div>
                                                    <label className="text-sm text-slate-600 font-medium">Payment type</label>
                                                    <select
                                                        className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                                        onChange={(e) => setPaymentType(e.target.value)}
                                                    >
                                                        <option selected value="0">Default price</option>
                                                        <option value="1">Custom price</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <label className="text-sm text-slate-600 font-medium">Pris (NOK)</label>
                                                    <input
                                                        type="number"
                                                        placeholder="0 for gratis"
                                                        onChange={(e) => setPrice(e.target.value)}
                                                        className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                                    />
                                                </div>
                                            </>
                                        )}
                                        <div>
                                            <label className="text-sm text-slate-600 font-medium">Schedule broadcast</label>

                                            <div className="flex items-center gap-6 mt-1">
                                                <label className="flex items-center gap-2 cursor-pointer">
                                                    <input
                                                        type="radio"
                                                        name="schedule"
                                                        checked={schedule === "Yes"}
                                                        onChange={() => setSchedule("Yes")}
                                                        className="h-4 w-4 accent-purple-600 border-2 border-purple-500"
                                                    />
                                                    <span className="text-gray-700">Yes</span>
                                                </label>

                                                <label className="flex items-center gap-2 cursor-pointer">
                                                    <input
                                                        type="radio"
                                                        name="schedule"
                                                        checked={schedule === "No"}
                                                        onChange={() => setSchedule("No")}
                                                        className="h-4 w-4 accent-purple-600 border-2 border-purple-500"
                                                    />
                                                    <span className="text-gray-700">No</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div>
                                            <label className="text-sm text-slate-600 font-medium">Remind me</label>

                                            <div className="flex items-center gap-6 mt-1">
                                                <label className="flex items-center gap-2 cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        checked={remindViaEmail === "Yes"}
                                                        onChange={(e) => setRemindViaEmail(e.target.checked ? "Yes" : "No")}
                                                        className="h-4 w-4 accent-purple-600 border-2 border-purple-500"
                                                    />
                                                    <span className="text-gray-700">Email</span>
                                                </label>

                                                <label className="flex items-center gap-2 cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        checked={remindViaSms === "Yes"}
                                                        onChange={(e) => setRemindViaSms(e.target.checked ? "Yes" : "No")}
                                                        className="h-4 w-4 accent-purple-600 border-2 border-purple-500"
                                                    />
                                                    <span className="text-gray-700">SMS</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* DATE & TIME FOR LIVE */}
                                    {type === "live" && schedule === "Yes" && (
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
                                            <div>
                                                <label className="text-sm text-slate-600 font-medium">Gjestetaler navn</label>
                                                <input
                                                    type="text"
                                                    placeholder="Gjestetaler navn"
                                                    className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                                    onChange={(e) => setGuestSpeakerName1(e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label className="text-sm text-slate-600 font-medium">Gjestetaler e-post</label>
                                                <input
                                                    type="text"
                                                    placeholder="Gjestetaler e-post"
                                                    className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                                    onChange={(e) => setGuestSpeakerEmail1(e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label className="text-sm text-slate-600 font-medium">Gjestetaler navn</label>
                                                <input
                                                    type="text"
                                                    placeholder="Gjestetaler navn"
                                                    className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                                    onChange={(e) => setGuestSpeakerName2(e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label className="text-sm text-slate-600 font-medium">Gjestetaler e-post</label>
                                                <input
                                                    type="text"
                                                    placeholder="Gjestetaler e-post"
                                                    className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                                    onChange={(e) => setGuestSpeakerName2(e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label className="text-sm text-slate-600 font-medium">Dato</label>
                                                <input
                                                    type="date"
                                                    className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                                    onChange={(e) => setDate(e.target.value)}
                                                />
                                            </div>

                                            <div>
                                                <label className="text-sm text-slate-600 font-medium">Starttid</label>
                                                <input
                                                    type="time"
                                                    className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                                    onChange={(e) => setTime(e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label className="text-sm text-slate-600 font-medium">Minutes before</label>
                                                <select onChange={(e) => setReminderMinutes(e.target.value)} className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500">
                                                    <option value="1">1</option>
                                                    <option value="5">5</option>
                                                    <option value="10">10</option>
                                                    <option value="15">15</option>
                                                    <option value="20">20</option>
                                                    <option value="30">30</option>
                                                    <option value="45">45</option>
                                                    <option value="60">60</option>
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    <div className="mb-6">
                                        <label className="text-sm text-slate-600 font-medium">Beskrivelse</label>
                                        <textarea
                                            rows={4}
                                            placeholder="Beskriv innholdet i kurset eller eventet..."
                                            onChange={(e) => setDescription(e.target.value)}
                                            className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                        />
                                    </div>

                                    {/* RELEASE OPTIONS FOR RECORDED */}
                                    {type === "recorded" && (
                                        <div className="mb-6">
                                            <label className="text-sm text-slate-600 font-medium">Publiseringsalternativ</label>
                                            <select className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500">
                                                <option>Slipp alt med en gang</option>
                                                <option>Slipp på valgt dato</option>
                                                <option>Slipp modul for modul</option>
                                            </select>
                                        </div>
                                    )}

                                    {/* MODULE SETUP FOR RECORDED */}
                                    {type === "recorded" && (
                                        <div className="mb-10 bg-white/50 p-6 rounded-2xl border border-slate-200">
                                            <h2 className="text-lg font-semibold text-slate-900 mb-4">Moduler</h2>

                                            <div className="space-y-4">
                                                <div className="p-4 bg-white rounded-xl border border-slate-300">
                                                    <label className="text-sm text-slate-600 font-medium">Modulnavn</label>
                                                    <input
                                                        type="text"
                                                        placeholder="F.eks: Introduksjon til temaet"
                                                        className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-purple-500"
                                                    />

                                                    <label className="text-sm text-slate-600 font-medium mt-4 block">Slippedato</label>
                                                    <input
                                                        type="date"
                                                        className="mt-1 w-full p-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-purple-500"
                                                    />
                                                </div>
                                            </div>

                                            <button className="mt-4 px-6 py-3 rounded-full bg-purple-500 text-white text-sm font-medium hover:bg-purple-600 transition">
                                                + Legg til modul
                                            </button>
                                        </div>
                                    )}

                                    {/* THUMBNAIL / INTRO VIDEO UPLOAD */}
                                    <div className="mb-10">
                                        <label className="text-sm text-slate-600 font-medium">Coverbilde eller introvideo</label>

                                        {/* Drag & Drop Area */}
                                        <div className="mt-3 w-full p-6 border-2 border-dashed border-slate-300 rounded-2xl bg-white hover:border-purple-500 transition cursor-pointer text-center"
                                            onDrop={handleFileDrop}
                                            onDragOver={handleDragOver}
                                            onClick={handleFileSelect}
                                        >
                                            <p className="text-slate-600 text-sm mb-2">Dra og slipp fil her, eller klikk for å laste opp</p>
                                            {uploadFile && (
                                                <p className="text-green-600 text-sm mb-2">{uploadFile.name}</p>
                                            )}
                                            <input onChange={handleFileSelect} type="file" accept="image/*,video/*" className="hidden" id="fileUpload" />
                                            <label htmlFor="fileUpload" className="px-4 py-2 mt-2 inline-block bg-purple-600 text-white rounded-full text-sm font-medium hover:bg-purple-700 transition cursor-pointer">
                                                Velg fil
                                            </label>
                                        </div>

                                        {/* Optional URL Field */}
                                        {/* <input
                                            type="text"
                                            placeholder="...eller lim inn URL til bilde/video"
                                            className="mt-4 w-full p-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-purple-500"
                                        /> */}
                                    </div>

                                    <div className="mb-3">
                                        {speakerPermissions && (
                                            <Permissions permissions={permissions} label={"Speaker"} name={speakerPermissions} setName={setSpeakerPermissions} />
                                        )}
                                    </div>
                                    <div className="mb-3">
                                        {participantPermissions && (
                                            <Permissions permissions={permissions} label={"Participant"} name={participantPermissions} setName={setParticipantPermissions} />
                                        )}
                                    </div>


                                    {/* SOCIAL SHARE */}
                                    <div className="mb-10">
                                        <p className="text-sm font-medium text-slate-600 mb-2">Del kurset på sosiale media</p>
                                        <div className="flex flex-wrap gap-4">
                                            <button className="p-3 rounded-full bg-blue-600 text-white hover:bg-blue-700 transition">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                                                    <path d="M22 12a10 10 0 1 0-11.5 9.9v-7h-2v-3h2V9.5c0-2 1.2-3.1 3-3.1.9 0 1.8.1 1.8.1v2h-1c-1 0-1.3.6-1.3 1.2V12h2.6l-.4 3h-2.2v7A10 10 0 0 0 22 12" />
                                                </svg>
                                            </button>

                                            <button className="p-3 rounded-full bg-black text-white hover:bg-neutral-900 transition">
                                                {/* Official X Logo (white X in black square) */}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect width="24" height="24" rx="6" fill="black" />
                                                    <path d="M18.146 5.25H20.7l-5.97 6.82 6.9 8.68h-4.65l-4.23-5.615L6.97 20.75H4.3l6.27-7.155L3.3 5.25h4.74l3.98 5.23 4.13-5.23z" fill="white" />
                                                </svg>
                                            </button>

                                            <button className="p-3 rounded-full bg-slate-800 text-white hover:bg-black transition">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.59 3.91a5.25 5.25 0 0 1 7.42 7.42l-9.33 9.33a4.5 4.5 0 0 1-6.36-6.36l8.49-8.49a3 3 0 1 1 4.24 4.24l-8.49 8.49" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>

                                    <button onClick={handleCreateBroadcastClick} className="px-10 py-4 rounded-full bg-purple-600 text-white text-lg font-semibold hover:bg-purple-700 transition w-full">
                                        Opprett
                                    </button>
                                </div>
                            </div>
                        </>

                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
